import { ChangeEvent, ReactNode } from 'react';
import { UseFormRegisterReturn } from 'react-hook-form';
import {
  Box,
  Checkbox as MuiCheckbox,
  SxProps,
  Theme,
  Typography,
} from '@mui/material';
import { TFunctionResult } from 'i18next';
import clsx from 'clsx';

// Components
import { Icon } from '../Icon/Icon';
import { ResultMessage } from '../ResultMessage/ResultMessage';

// Models
import { ResultState } from '../../models/shared.types';

// Styles
import styles from './CheckboxWithLabel.module.scss';
import { FormFieldLabel } from '../FormFieldLabel/FormFieldLabel';

type CheckboxWithLabelProps = {
  classes?: string;
  checked?: boolean;
  color?:
    | 'primary'
    | 'secondary'
    | 'error'
    | 'info'
    | 'success'
    | 'warning'
    | 'default';
  content?: string | ReactNode;
  disabled?: boolean;
  label: TFunctionResult | string;
  sublabel?: TFunctionResult | string;
  text?: string;
  optional?: boolean;
  logo?: string;
  message?: TFunctionResult | string;
  register?: UseFormRegisterReturn;
  state?: ResultState;
  sx?: SxProps<Theme>;
  onChange?: (checked: boolean) => void;
};

export const CheckboxWithLabel = (props: CheckboxWithLabelProps) => {
  return (
    <Box
      className={styles['checkbox']}
      sx={{
        '& .MuiCheckbox-root': {
          padding: '0.25rem',
        },
      }}
    >
      <div className="flex flex-row items-center">
        <MuiCheckbox
          className={props.classes && props.classes}
          checked={props.checked && props.checked}
          checkedIcon={<Icon icon={['fas', 'check-square']} size="small" />}
          color={props.color ?? 'primary'}
          disabled={props.disabled}
          icon={<Icon icon={['fal', 'square']} size="small" />}
          onChange={(event: ChangeEvent<HTMLInputElement>) =>
            props.onChange && props.onChange(event.target.checked)
          }
          {...props.register}
        />
        {props.label && (
          <FormFieldLabel
            label={props.label}
            optional={props.optional}
            sublabel={props.sublabel}
          />
        )}
        {props.text && (
          <Typography className="pl-2 text-xs">{props.text}</Typography>
        )}
      </div>
      {props.message && (
        <ResultMessage
          message={props.message}
          state={props.state ?? ResultState.Error}
        />
      )}
    </Box>
  );
};
